module.exports = __webpack_public_path__ + "static/media/Poppins-ExtraBold.51d1fa70.woff";